module.exports = __webpack_public_path__ + "img/ar.3e880c09.png";